import React from "react";

import * as S from "../styled";
import { ModalContext } from "../SuccessMessageModal";

function Footer(props) {
  return (
    <ModalContext.Consumer>
      {context => <S.ModalFooter {...props} layout={context.layout} />}
    </ModalContext.Consumer>
  );
}

export default Footer;
